import React, { useEffect } from "react";

import moment, { MomentInput } from "moment";

import Loading from "ds/PageLoading";
import { useLoadOrder } from "Reducers/organization/order/hooks/useLoadOrder";
import { loadSubscriptions } from "Reducers/organization/subscription";
import { useAppDispatch } from "Store/hooks";

import InvoiceHeader from "./Header/InvoiceHeader";
import * as S from "./Invoice.styles";
import InvoiceOrganization from "./InvoiceOrganization/InvoiceOrganization";
import InvoiceProjects from "./InvoiceProjects/InvoiceProjects";
import InvoiceSummary from "./Summary/InvoiceSummary";
import InvoiceSupport from "./Support/InvoiceSupport";

type InvoiceType = {
  organizationId: string;
  orderId: string;
};

const Invoice = ({ organizationId, orderId }: InvoiceType) => {
  const { order, loading } = useLoadOrder({
    organizationId,
    orderId
  });
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (organizationId) {
      dispatch(loadSubscriptions({ organizationId: organizationId ?? "" }));
    }
  }, [organizationId, dispatch]);

  if (loading || !order) {
    return <Loading />;
  }

  const organizationFeatureItems = order?.line_items?.filter(
    item =>
      item.type === "organization_feature" ||
      item.product === "Onboarding - Training"
  );
  const organizationItems = organizationFeatureItems?.filter(
    item => !item.product.match(/support/i)
  );
  const organizationSupportItems = organizationFeatureItems?.filter(item =>
    item.product.match(/support/i)
  );

  const orderCurrency =
    organizationItems[0]?.components?.base_price?.currency || order.currency;
  const durationDate = (date: MomentInput) => moment(date).format("MMM D");

  return (
    <S.InvoiceWrapper>
      <InvoiceHeader order={order} />
      <InvoiceOrganization
        durationDate={durationDate}
        orderCurrency={orderCurrency}
        organizationItems={organizationItems}
      />
      <InvoiceProjects
        organizationId={organizationId}
        order={order}
        orderCurrency={orderCurrency}
      />
      <InvoiceSupport
        durationDate={durationDate}
        orderCurrency={orderCurrency}
        organizationItems={organizationSupportItems}
      />
      <InvoiceSummary order={order} orderCurrency={orderCurrency} />
    </S.InvoiceWrapper>
  );
};

export default Invoice;
